import { render, staticRenderFns } from "./OrderState.vue?vue&type=template&id=23e6a49a&scoped=true"
import script from "./OrderState.vue?vue&type=script&lang=js"
export * from "./OrderState.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-co_9d3e8444ee7ad6f099877d142dfca7ea/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e6a49a",
  null
  
)

export default component.exports